import ProductSpace from "../../../src/visualization/connectedCharts/ConnectedProductSpace";
import { buildMeta } from "../../routeMeta";

export function meta(args) {
  return buildMeta(
    {
      title: "Product Space — The Atlas of Economic Complexity",
      description:
        "Explore a country's exports against the network of relatedness between products.",
      ogImage: "share_ps.png",
    },
    args,
  );
}

export default function ProductSpaceRoute() {
  return <ProductSpace />;
}
